// extracted by mini-css-extract-plugin
export var error = "error-module--error--5O+t4";
export var error__code = "error-module--error__code--htDzq";
export var error__title = "error-module--error__title--Rvu2a";
export var error__desc = "error-module--error__desc--cYv28";
export var error__gradient = "error-module--error__gradient--W9BTA";
export var error__gradient_light = "error-module--error__gradient_light--XFTZ+";